import { LogicTypes } from 'modules/shared/DataGrid';

export const GET_ORDERING_TRIPS_REQUEST = 'GET_ORDERING_TRIPS_REQUEST' as const;
export const GET_ORDERING_UNLOADING_TRIPS_REQUEST = 'GET_ORDERING_UNLOADING_TRIPS_REQUEST' as const;
export const GET_ORDERING_TRIPS_SUCCESS = 'GET_ORDERING_TRIPS_SUCCESS' as const;
export const GET_ORDERING_TRIPS_ERROR = 'GET_ORDERING_TRIPS_ERROR' as const;

export const fieldsNames = [
  'id',
  'arrivalDate',
  'driver',
  'driverPhone',
  'isFastLineDriver',
  'isFastLineForwarder',
  'forwarder',
  'forwarderPhone',
  'orders',
  'status',
];

export const AWAITING_REGISTER_STATUS_ID = 2;
export const MIN_FILTER_VALUE_LENGTH = 3;

export const defaultGridState = {
  sort: [],
  filter: {
    logic: LogicTypes.and,
    filters: [],
  },
  pagination: { skip: 0, pageSize: 15 },
};

export const GetTripColumnsNames = (isLoading: boolean) => {
  const res = {
    id: 'Рейс',
    bookingDate: 'Дата бронювання',
    statusStr: 'Статус',
    driver: 'Водій',
    driverPhone: 'Телефон',
    arrivalDate: "В'їзд",
  };

  if (isLoading) {
    // @ts-ignore
    res.orders = 'Номер Наряда';
    // @ts-ignore
    res.factWeightGrouped = 'Фактична вага,т (ТСД)';
    // @ts-ignore
    res.factoryNumber = 'Номер Заводу';
    // @ts-ignore
    res.warehouseCode = 'Номер Складу';
  } else {
    // @ts-ignore
    res.unloadingLocation = 'Локація';
    // @ts-ignore
    res.unloadingFactory = 'Номер Заводу';
    // @ts-ignore
    res.unloadingWarehouse = 'Номер Складу';
  }
  return res;
};
